import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FullScreenMapComponent } from './full-screen-map/full-screen-map.component';
import { MapComponent } from './map.component';
import { DvButtonComponent, DvDialogContentComponent } from '@devinco/ui/dds';

@NgModule({
  declarations: [MapComponent, FullScreenMapComponent],
  exports: [MapComponent],
  imports: [
    CommonModule,
    DvButtonComponent,
    TranslateModule,
    DvDialogContentComponent,
  ],
})
export class MapModule {}
